import React from 'react';
import PropTypes from 'prop-types';
import { Type } from '@nerdwallet/currency';
import LoadingN from '@nerdwallet/react-loading-n';

const CredibleInterstitialArt = ({ product, suppressRedirect }) => {
  return (
    <div className="credible-container">
      <div className="credible-design">
        <LoadingN className="credible-nw-logo" size={60} />
        <div className="credible-dots">
          <div className="credible-ellipse" />
          <div className="credible-ellipse" />
          <div className="credible-ellipse" />
        </div>
        <img className="credible-image" src={product.imageSource} alt="" />
      </div>
      <Type className="credible-text" size="2-half">
        Hang tight! We&apos;re redirecting you to{' '}
        <Type bold>{product.institutionName}&apos;s Website.</Type>
      </Type>
      {suppressRedirect && <Type>Redirect suppressed.</Type>}
    </div>
  );
};

CredibleInterstitialArt.propTypes = {
  product: PropTypes.shape({
    imageSource: PropTypes.string,
    institutionName: PropTypes.string,
  }),
  suppressRedirect: PropTypes.bool,
};

export default CredibleInterstitialArt;
